import ProgramService from "@/services/ProgramService.js";

export const namespaced = true;

export const state = {
    institutions: [],
    programs: [],
    programDetails: []
};

export const getters = {
    getInstitutionsWithPrograms: state => {
        return state.institutions;
    },

    getPrograms: state => {
        return state.programs;
    },

    getProgramDetails: state => {
        return state.programDetails;
    }
};

export const mutations = {
    SET_INSTITUTIONS(state, institutions) {
        state.institutions = institutions;
    },
    SET_PROGRAMS(state, programs) {
        state.programs = programs;
    },

    SET_PROGRAM_DETAILS(state, programDetails) {
        state.programDetails = programDetails[0];
    }
};

export const actions = {
    fetchInstitutions({ commit }) {
        ProgramService.fetchCollegeList().then(response => {
            commit("SET_INSTITUTIONS", response.data.data);
        });
    },

    fetchProgramsByInstitution({ commit }, college) {
        ProgramService.fetchCollegeDetail(college).then(response => {
            commit("SET_PROGRAMS", response.data.data);
        });
    },

    fetchProgramDetails({ commit }, program) {
        ProgramService.fetchProgramDetail(program).then(response => {
            commit("SET_PROGRAM_DETAILS", response.data.data);
        });
    }
};
